/* eslint-disable no-unused-vars */
import React from "react";

// eslint-disable-next-line no-unused-vars
import { BsPlayCircle } from "react-icons/bs";
// eslint-disable-next-line no-unused-vars
import Image01 from "../assets/claimConversation.svg";
import Audio from "./Media/Audio";

const MyClaimsConversation = ({ type, note }) => {
  
  return (
    <div className="flex flex-col items-start mb-3 pl-5">
      <div className={`flex items-center ${!type === "video" && "border-2 rounded-xl py-2 px-4"}`}>
        {type === "message" ? (
          <div>
            <p className="text-sm">This is a email conversions</p>
            <p className="text-xs">click to view </p>
          </div>
        ) : (type === "image") ? (
          <div className="relative">
            <img src={note} className="w-3/6 rounded-xl" alt="" />
          </div>
        ) : type === "video" ? (
          <div className="relative">
            <video width="320" className="rounded-xl" autoPlay={false} height="380" controls >
              <source src={note} type="video/*" />
            </video>
          </div>
        ) : type === "details" ? (
          <div className="relative">
            <img src={Image01} alt="" />
            <div className="absolute top-0 w-full h-full bg-[#000] bg-opacity-60 text-white rounded-lg flex justify-center items-center">
              <BsPlayCircle className="text-3xl cursor-pointer" />
              ok
            </div>
          </div>
        ) : type === "files" ? (
          <div className="relative">
            <img src={Image01} alt="" />
            <div className="absolute top-0 w-full h-full bg-[#000] bg-opacity-60 text-white rounded-lg flex justify-center items-center">
              <BsPlayCircle className="text-3xl cursor-pointer" />
            </div>
          </div>
        ) : (
          type === "audio" && (
           <Audio src={note}  />
          )
        )}
      </div>
    </div>
  );
};

export default MyClaimsConversation;
